<!-- Условие очень не надежное, надо это усилить -->
<ng-container *ngIf="(active$ | async) === 'delivery'; else pickup">
  <sd-delivery-address-block></sd-delivery-address-block>

  <div *ngIf="deliveryAddressService.addressCityMatches$ | async as cities" class="wrong-city-alert">
    <ng-container
      *ngIf="{ currentCityMismatchValidationErrors: currentCityMismatchValidationErrors$ | async } as errors"
    >
      <div *ngFor="let err of errors.currentCityMismatchValidationErrors" class="error-msg alert-danger" role="alert">
        {{ errors.currentCityMismatchValidationErrors }}
      </div>

      <div class="error-msg" *ngIf="cities.length && !errors.currentCityMismatchValidationErrors?.length">
        Город в адресе доставки не соответствует текущему городу
      </div>

      <button *ngFor="let city of cities" (click)="setCorrectionCity(city.point)" type="button" class="wrong-city-btn">
        я в г. {{ city.name }}
      </button>
    </ng-container>
  </div>

  <div *ngIf="deliveryValidationErrors$ | async as errors">
    <div *ngFor="let err of errors" class="error-msg alert-danger" role="alert">
      {{ errors }}
    </div>
  </div>
</ng-container>

<ng-template #pickup>
  <sd-pickup-address></sd-pickup-address>
  <div *ngIf="pickupValidationErrors$ | async as errors">
    <div *ngFor="let err of errors" class="error-msg alert-danger" role="alert">
      {{ errors }}
    </div>
  </div>
</ng-template>
